import styled from "styled-components";

export const Link = styled.a`
  color: #000;

  &:hover {
    color: #000;
    text-decoration: underline;
  }

  &:link {
    color: #000;
  }
`;

export const Status = styled.span`
  color: ${props => props?.color || '#000'};
  font-weight: 600;
  text-transform: uppercase;
`;

export const TutorAvatar = styled.img`
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  display: block;
  margin: 0 auto;
`;

export const DoubtContainer = styled.div`
  max-height: 100px;
  overflow: auto;
  font-size: 0.9rem;

  /** Hide ScrolllBar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;